document.body.addEventListener('click', function (evt) {
    if(evt.target instanceof HTMLElement) {
        if (evt.target.classList.contains('custom-tab')) {
            const target = evt.target.getAttribute('data-target');
            if (target) {
                const parent = evt.target.closest('.custom-tabs');
                if (parent) {
                    const currentActiveTab = parent.querySelector('.custom-tab.active');
                    if (currentActiveTab) {
                        currentActiveTab.classList.remove('active');
                    }
                    evt.target.classList.add('active');
                    const currentactiveTabContent = parent.querySelector('.custom-tab-content.active');
                    if (currentactiveTabContent) {
                        currentactiveTabContent.classList.remove('active');
                    }
                    const targetContent = document.getElementById(target);
                    if(targetContent) {
                        targetContent.classList.add('active');
                    }
                }
            }
        }
    }
})